import {
  careLevelToTocMap,
  tocToCareLevelMap,
} from '@react/widgets/pricingCalculator/constants';

const filterToRoomTypeMap = {
  private: 'privateSuiteRate',
  shared: 'sharedSuiteRate',
  studio: 'studioApartmentRate',
};

const getTocFromCareLevel = (careLevel) => {
  return careLevelToTocMap[careLevel] || 'independent-living';
};

export const getCareLevelFromToc = (toc) => {
  return tocToCareLevelMap[toc] || 'light-care';
};

export const getFiltersFromFormValues = (values) => {
  const filters = {};
  const searchParams = values?.location?.searchParams;

  if (searchParams?.state) {
    filters.state = searchParams.state;
  }
  if (searchParams?.city) {
    filters.city = searchParams.city;
  }
  filters.toc = getTocFromCareLevel(values?.careLevel);

  return filters;
};

export const getPricingFromGeoGuides = ({
  roomType,
  mobility,
  careLevel,
  geoGuidesData,
}) => {
  if (!geoGuidesData?.length) {
    return null;
  }
  const roomTypeKeyFromFilter = filterToRoomTypeMap[roomType];

  const [geoGuide] = geoGuidesData;
  const { info: { pricingStats: { estimatedPrices } = {} } = {} } =
    geoGuide || {};

  if (!estimatedPrices) return new Map();

  const roomSizeOrder = ['small', 'medium', 'large'];

  const mobilityMultiplier = !!mobility && mobility !== 'no-issues' ? 1.1 : 1;
  const careLevelMultiplier = careLevel === 'light-care' ? 1.1 : 1;
  const multiplier = mobilityMultiplier * careLevelMultiplier;

  const prices = Object.entries(estimatedPrices).reduce((acc, [key, value]) => {
    const currentRoomTypeBySize = value?.[roomTypeKeyFromFilter];
    if (currentRoomTypeBySize) {
      acc.set(key, currentRoomTypeBySize * multiplier);
    }
    return acc;
  }, new Map());

  const sortedPricesByKey = roomSizeOrder.reduce((acc, curr) => {
    if (prices.has(curr)) {
      acc.set(curr, prices.get(curr));
    }
    return acc;
  }, new Map());

  return sortedPricesByKey;
};
